import { BUTTON_SIZE, BUTTON_TYPE, COLORS, DSButton } from '@repo/design-system/index'
import { QIcon_clock, QIcon_close_default, QIcon_pen } from '@repo/icons/index'
import dynamic from 'next/dynamic'
import * as animationData from '../../../../animations/complete_firework.json'
import { useExpressionCount, useLessonDetail } from '../../../../modules/apis/student/ai-tutor'
import { n_ai_speaking, n_ai_tutor, n_common } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { AITutorKeyExpressionList } from '../AITutorCard'
const Lottie = dynamic(() => import('react-lottie'), { ssr: false })

const DoneDefault = ({ duration, lessonId, close, nextLesson }) => {
  const min = Math.floor(duration / 60 / 1000)
  const sec = Math.floor((duration / 1000) % 60)
  const { data: lessonData } = useLessonDetail(lessonId)
  const { data: expressionCountData } = useExpressionCount()
  const { t } = useTranslation()
  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

  return (
    <div className="my-[14px] px-[20px] flex flex-col items-center justify-between">
      <div className="flex w-full flex-col items-end justify-center self-stretch">
        <QIcon_close_default onClick={close} width={24} height={24} />
      </div>
      <div className="flex flex-col gap-[12px] items-center justify-start self-stretch mt-[12px]">
        <Lottie options={defaultOptions} height={140} isClickToPauseDisabled={true} />
        <div className="flex flex-col gap-[4px] items-start justify-start self-stretch">
          <h2 className="text-black text-center text-[24px] leading-[32px] font-bold self-stretch">
            {t(n_ai_tutor.study_activity.complete_title)}
          </h2>
          <p className="text-gray-500 text-center text-[16px] leading-[24px] self-stretch">
            {t(n_ai_tutor.study_activity.complete_detail)}
          </p>
        </div>
      </div>
      <div className="flex flex-col gap-[24px] items-start justify-start self-stretch mt-[75px] mb-[52px]">
        <div className="flex flex-row gap-[12px] items-center justify-start w-full">
          <div className="bg-gray-100 rounded-xl p-[6px] flex flex-col gap-[4px] items-center justify-start flex-1">
            <div className="text-gray-500 text-center text-[14px] leading-[20px] self-stretch">
              {t(n_ai_tutor.study_activity.timespent)}
            </div>
            <div className="bg-white rounded-lg py-[8px] flex flex-row gap-[4px] items-center justify-center self-stretch">
              <QIcon_clock width={20} height={20} fill={COLORS.BLUE400} />
              <div className="text-gray-600 text-left text-[20px] leading-[28px] font-bold">
                {min.toString().padStart(2, '0')}:{sec.toString().padStart(2, '0')}
              </div>
            </div>
          </div>
          <div className="bg-gray-100 rounded-xl p-[6px] flex flex-col gap-[4px] items-center justify-start flex-1">
            <div className="text-gray-500 text-center text-[14px] leading-[20px] self-stretch">
              {t(n_ai_tutor.study_activity.count_study)}
            </div>
            <div className="bg-white rounded-lg py-[8px] flex flex-row gap-[4px] items-center justify-center self-stretch">
              <QIcon_pen width={20} height={20} fill={COLORS.RED400} />
              <div className="text-gray-600 text-left text-[20px] leading-[28px] font-bold">
                {expressionCountData}
                {t(n_ai_speaking.count)}
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-[12px] items-start justify-start self-stretch">
          <h3 className="Body1-16Bd text-gray-700 text-left ">{t(n_ai_tutor.study_activity.key_espression)}</h3>
          <AITutorKeyExpressionList lesson={lessonData} />
        </div>
      </div>
      <div className="w-full bg-white py-[12px] sticky bottom-[20px] left-[0px]">
        <DSButton size={BUTTON_SIZE.MD} type={BUTTON_TYPE.SOLID} onClick={nextLesson}>
          <DSButton.Label>{t(n_common.btn_continue)}</DSButton.Label>
        </DSButton>
      </div>
    </div>
  )
}

export default DoneDefault
